module.exports = __webpack_public_path__ + "static/img/robot.09cfe8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/robot.png
// module id = aHsp
// module chunks = 15